module.exports = "<p>\n  common works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/common/common.component.html
// module id = 652
// module chunks = 16